/**
 * @desc 查询中台系统发货明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/getOrderPackageDetailVo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
